export default "__VITE_ASSET__BWwg7wbK__"